var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c(
          "wes-message",
          _vm._b({}, "wes-message", _vm.getMessagePanel(), false)
        ),
        _vm._v(" "),
        _vm._t("filtro"),
        _vm._v(" "),
        this.showCheckBox && this.data && this.data.length > 0
          ? _c(
              "div",
              [
                _vm._v("\n            Mostrar:  \n            "),
                _vm._l(
                  this.fields.filter(function (item) {
                    return item.groupIndex >= 0 && item.groupName !== "Date"
                  }),
                  function (item, index) {
                    return _c(
                      "label",
                      { key: index, staticClass: "mt-checkbox" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.caption + "     ") +
                            "\n                "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.visible,
                              expression: "item.visible",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(item.visible)
                              ? _vm._i(item.visible, null) > -1
                              : item.visible,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.checkClick(item)
                            },
                            change: function ($event) {
                              var $$a = item.visible,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(item, "visible", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "visible",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "visible", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                      ]
                    )
                  }
                ),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { id: "pivotgrid" } }),
        _vm._v(" "),
        _vm.exportDialog.visible
          ? _c(
              "div",
              {
                staticClass: "modal fade in balancete-export-dialog",
                staticStyle: { display: "block" },
                attrs: { tabindex: "-1", role: "dialog" },
              },
              [
                _c("div", { staticClass: "modal-dialog" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelarExportacaoExcel },
                        },
                        [_vm._v("×")]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v("Parâmetros para impressão"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "ul",
                        { staticClass: "nav nav-tabs balancete-export-tabs" },
                        [
                          _c(
                            "li",
                            {
                              class: {
                                active:
                                  _vm.exportDialog.abaAtiva === "formatacao",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportDialog.abaAtiva = "formatacao"
                                    },
                                  },
                                },
                                [_vm._v("Formatação")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              class: {
                                active:
                                  _vm.exportDialog.abaAtiva === "assinaturas",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportDialog.abaAtiva = "assinaturas"
                                    },
                                  },
                                },
                                [_vm._v("Assinaturas")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              class: {
                                active: _vm.exportDialog.abaAtiva === "arquivo",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportDialog.abaAtiva = "arquivo"
                                    },
                                  },
                                },
                                [_vm._v("Arquivo")]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.exportDialog.abaAtiva === "formatacao",
                              expression:
                                "exportDialog.abaAtiva === 'formatacao'",
                            },
                          ],
                          staticClass: "row balancete-export-tab-content",
                        },
                        [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("fieldset", [
                              _c("legend", [_vm._v("Cabeçalho")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Esquerda:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .CabecalhoEsquerda,
                                      expression:
                                        "exportDialog.parametros.CabecalhoEsquerda",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros
                                        .CabecalhoEsquerda,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "CabecalhoEsquerda",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Centro:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .CabecalhoCentro,
                                      expression:
                                        "exportDialog.parametros.CabecalhoCentro",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros
                                        .CabecalhoCentro,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "CabecalhoCentro",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Direita:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .CabecalhoDireita,
                                      expression:
                                        "exportDialog.parametros.CabecalhoDireita",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros
                                        .CabecalhoDireita,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "CabecalhoDireita",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("fieldset", [
                              _c("legend", [_vm._v("Rodapé")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Esquerda:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .RodapeEsquerda,
                                      expression:
                                        "exportDialog.parametros.RodapeEsquerda",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros
                                        .RodapeEsquerda,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "RodapeEsquerda",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Centro:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .RodapeCentro,
                                      expression:
                                        "exportDialog.parametros.RodapeCentro",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros.RodapeCentro,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "RodapeCentro",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Direita:")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .RodapeDireita,
                                      expression:
                                        "exportDialog.parametros.RodapeDireita",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.exportDialog.parametros.RodapeDireita,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "RodapeDireita",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("fieldset", [
                              _c("legend", [_vm._v("Centralizar na página")]),
                              _vm._v(" "),
                              _c("label", { staticClass: "checkbox-inline" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .CentralizarHorizontalmente,
                                      expression:
                                        "exportDialog.parametros.CentralizarHorizontalmente",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.exportDialog.parametros
                                        .CentralizarHorizontalmente
                                    )
                                      ? _vm._i(
                                          _vm.exportDialog.parametros
                                            .CentralizarHorizontalmente,
                                          null
                                        ) > -1
                                      : _vm.exportDialog.parametros
                                          .CentralizarHorizontalmente,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.exportDialog.parametros
                                            .CentralizarHorizontalmente,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "CentralizarHorizontalmente",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "CentralizarHorizontalmente",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.exportDialog.parametros,
                                          "CentralizarHorizontalmente",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                        Horizontalmente\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("label", { staticClass: "checkbox-inline" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.exportDialog.parametros
                                          .CentralizarVerticalmente,
                                      expression:
                                        "exportDialog.parametros.CentralizarVerticalmente",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.exportDialog.parametros
                                        .CentralizarVerticalmente
                                    )
                                      ? _vm._i(
                                          _vm.exportDialog.parametros
                                            .CentralizarVerticalmente,
                                          null
                                        ) > -1
                                      : _vm.exportDialog.parametros
                                          .CentralizarVerticalmente,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.exportDialog.parametros
                                            .CentralizarVerticalmente,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "CentralizarVerticalmente",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "CentralizarVerticalmente",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.exportDialog.parametros,
                                          "CentralizarVerticalmente",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                        Verticalmente\n                                    "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("fieldset", [
                              _c("legend", [_vm._v("Margens (polegadas)")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("label", [_vm._v("Esquerda:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .MargemEsquerda,
                                          expression:
                                            "exportDialog.parametros.MargemEsquerda",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", step: "0.1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .MargemEsquerda,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "MargemEsquerda",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("label", [_vm._v("Topo:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .MargemTopo,
                                          expression:
                                            "exportDialog.parametros.MargemTopo",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", step: "0.1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .MargemTopo,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "MargemTopo",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("label", [_vm._v("Direita:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .MargemDireita,
                                          expression:
                                            "exportDialog.parametros.MargemDireita",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", step: "0.1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .MargemDireita,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "MargemDireita",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("label", [_vm._v("Fundo:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .MargemFundo,
                                          expression:
                                            "exportDialog.parametros.MargemFundo",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", step: "0.1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .MargemFundo,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "MargemFundo",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("fieldset", [
                              _c("legend", [_vm._v("Reduzir para")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .ReduzirPaginasHorizontais,
                                          expression:
                                            "exportDialog.parametros.ReduzirPaginasHorizontais",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", min: "-1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .ReduzirPaginasHorizontais,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "ReduzirPaginasHorizontais",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("páginas horizontais")]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 form-group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value:
                                            _vm.exportDialog.parametros
                                              .ReduzirPaginasVerticais,
                                          expression:
                                            "exportDialog.parametros.ReduzirPaginasVerticais",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", min: "-1" },
                                      domProps: {
                                        value:
                                          _vm.exportDialog.parametros
                                            .ReduzirPaginasVerticais,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.exportDialog.parametros,
                                            "ReduzirPaginasVerticais",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("páginas verticais")]),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "fieldset",
                              { staticClass: "balancete-export-options" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "checkbox-inline" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.exportDialog.parametros
                                              .DaEsquerdaParaDireita,
                                          expression:
                                            "exportDialog.parametros.DaEsquerdaParaDireita",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.exportDialog.parametros
                                            .DaEsquerdaParaDireita
                                        )
                                          ? _vm._i(
                                              _vm.exportDialog.parametros
                                                .DaEsquerdaParaDireita,
                                              null
                                            ) > -1
                                          : _vm.exportDialog.parametros
                                              .DaEsquerdaParaDireita,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.exportDialog.parametros
                                                .DaEsquerdaParaDireita,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "DaEsquerdaParaDireita",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "DaEsquerdaParaDireita",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "DaEsquerdaParaDireita",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                                        da esquerda p/direita\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "checkbox-inline" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.exportDialog.parametros
                                              .IgnorarCores,
                                          expression:
                                            "exportDialog.parametros.IgnorarCores",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.exportDialog.parametros
                                            .IgnorarCores
                                        )
                                          ? _vm._i(
                                              _vm.exportDialog.parametros
                                                .IgnorarCores,
                                              null
                                            ) > -1
                                          : _vm.exportDialog.parametros
                                              .IgnorarCores,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.exportDialog.parametros
                                                .IgnorarCores,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "IgnorarCores",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "IgnorarCores",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "IgnorarCores",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                                        Ignorar cores\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "checkbox-inline" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.exportDialog.parametros
                                              .LinhasDeGrade,
                                          expression:
                                            "exportDialog.parametros.LinhasDeGrade",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.exportDialog.parametros
                                            .LinhasDeGrade
                                        )
                                          ? _vm._i(
                                              _vm.exportDialog.parametros
                                                .LinhasDeGrade,
                                              null
                                            ) > -1
                                          : _vm.exportDialog.parametros
                                              .LinhasDeGrade,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.exportDialog.parametros
                                                .LinhasDeGrade,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "LinhasDeGrade",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "LinhasDeGrade",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "LinhasDeGrade",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                                        Linhas de grade\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "checkbox-inline" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.exportDialog.parametros
                                              .Paisagem,
                                          expression:
                                            "exportDialog.parametros.Paisagem",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.exportDialog.parametros.Paisagem
                                        )
                                          ? _vm._i(
                                              _vm.exportDialog.parametros
                                                .Paisagem,
                                              null
                                            ) > -1
                                          : _vm.exportDialog.parametros
                                              .Paisagem,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.exportDialog.parametros
                                                .Paisagem,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "Paisagem",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.exportDialog.parametros,
                                                  "Paisagem",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.exportDialog.parametros,
                                              "Paisagem",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                                        Paisagem\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.exportDialog.abaAtiva === "assinaturas",
                              expression:
                                "exportDialog.abaAtiva === 'assinaturas'",
                            },
                          ],
                          staticClass: "balancete-export-tab-content",
                        },
                        [
                          _c("fieldset", [
                            _c("legend", [_vm._v("Cabeçalhos adicionais")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.exportDialog.parametros
                                      .CabecalhoAdicional,
                                  expression:
                                    "exportDialog.parametros.CabecalhoAdicional",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "4" },
                              domProps: {
                                value:
                                  _vm.exportDialog.parametros
                                    .CabecalhoAdicional,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.exportDialog.parametros,
                                    "CabecalhoAdicional",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [_vm._v("Assinaturas da esquerda")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.exportDialog.parametros
                                      .AssinaturaEsquerda,
                                  expression:
                                    "exportDialog.parametros.AssinaturaEsquerda",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "4" },
                              domProps: {
                                value:
                                  _vm.exportDialog.parametros
                                    .AssinaturaEsquerda,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.exportDialog.parametros,
                                    "AssinaturaEsquerda",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [_vm._v("Assinaturas da direita")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.exportDialog.parametros
                                      .AssinaturaDireita,
                                  expression:
                                    "exportDialog.parametros.AssinaturaDireita",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "4" },
                              domProps: {
                                value:
                                  _vm.exportDialog.parametros.AssinaturaDireita,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.exportDialog.parametros,
                                    "AssinaturaDireita",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [
                              _vm._v("Espaçamento das assinaturas"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(
                                  "Quantidade de linhas entre o final da planilha e as assinaturas:"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value:
                                      _vm.exportDialog.parametros
                                        .EspacamentoAssinaturas,
                                    expression:
                                      "exportDialog.parametros.EspacamentoAssinaturas",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", min: "0" },
                                domProps: {
                                  value:
                                    _vm.exportDialog.parametros
                                      .EspacamentoAssinaturas,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.exportDialog.parametros,
                                      "EspacamentoAssinaturas",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.exportDialog.abaAtiva === "arquivo",
                              expression: "exportDialog.abaAtiva === 'arquivo'",
                            },
                          ],
                          staticClass: "balancete-export-tab-content",
                        },
                        [
                          _c("fieldset", [
                            _c("legend", [_vm._v("Formato")]),
                            _vm._v(" "),
                            _c("label", { staticClass: "radio-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.exportDialog.parametros.FormatoSaida,
                                    expression:
                                      "exportDialog.parametros.FormatoSaida",
                                  },
                                ],
                                attrs: { type: "radio", value: "XLSX" },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.exportDialog.parametros.FormatoSaida,
                                    "XLSX"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "FormatoSaida",
                                        "XLSX"
                                      )
                                    },
                                    function ($event) {
                                      return _vm.alterarFormatoSaida("XLSX")
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n                                    Excel\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "radio-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.exportDialog.parametros.FormatoSaida,
                                    expression:
                                      "exportDialog.parametros.FormatoSaida",
                                  },
                                ],
                                attrs: { type: "radio", value: "PDF" },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.exportDialog.parametros.FormatoSaida,
                                    "PDF"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.exportDialog.parametros,
                                        "FormatoSaida",
                                        "PDF"
                                      )
                                    },
                                    function ($event) {
                                      return _vm.alterarFormatoSaida("PDF")
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n                                    PDF\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [_vm._v("Nome do arquivo")]),
                            _vm._v(" "),
                            _c("label", [_vm._v("Expressão:")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.exportDialog.parametros
                                      .ExpressaoNomeArquivo,
                                  expression:
                                    "exportDialog.parametros.ExpressaoNomeArquivo",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.exportDialog.parametros
                                    .ExpressaoNomeArquivo,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.exportDialog.parametros,
                                    "ExpressaoNomeArquivo",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn default",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inserirTokenNomeArquivo(
                                          "{EMPRESA}"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Empresa")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn default",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inserirTokenNomeArquivo(
                                          "{PERIODO}"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Período")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn default",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inserirTokenNomeArquivo(
                                          "{PERFIL_BALANCETE}"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Perfil balancete")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "help-block",
                                staticStyle: { "margin-top": "12px" },
                              },
                              [
                                _c("strong", [_vm._v("Nome final:")]),
                                _vm._v(
                                  " " + _vm._s(_vm.nomeArquivoBalancetePreview)
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn default pull-left",
                          attrs: { type: "button" },
                          on: { click: _vm.definirParametrosExportacaoPadrao },
                        },
                        [_vm._v("Padrão")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn blue",
                          attrs: { type: "button" },
                          on: { click: _vm.confirmarExportacaoExcel },
                        },
                        [_vm._v("OK")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn default",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelarExportacaoExcel },
                        },
                        [_vm._v("Cancelar")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.exportDialog.visible
          ? _c("div", { staticClass: "modal-backdrop fade in" })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }